/**
 * RentalsPromoAside.jsx
 * Created by Destin Frasier on 9/04/20.
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as GearRentalIcons from '../icons/gearRental/GearRentalIcons';
import Button from '../Button/Button';
import { ExternalLink } from '../Link';

export default function RentalsPromoAside({
    copy,
    className,
    buttonCopy,
    href,
    alt,
    isInternalLink,
}) {
    return (
        <div className={cx('rec-rentals-promo-aside-wrap', className)}>
            <div className="rec-rentals-promo-aside-inner-wrap">
                <div className="rec-rentals-promo-aside-icon-wrap">
                    <GearRentalIcons.RentalTent />
                </div>

                <p>{copy}</p>
                {isInternalLink ? (
                    <Button
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        screenReaderTextAfter={alt}
                    >
                        {buttonCopy}
                    </Button>
                ) : (
                    <ExternalLink
                        url={href}
                        target="_blank"
                        alt={alt}
                        rel="noopener noreferrer"
                    >
                        <Button>{buttonCopy}</Button>
                    </ExternalLink>
                )}
            </div>
        </div>
    );
}

RentalsPromoAside.propTypes = {
    /** Copy for the promo */
    copy: PropTypes.string,

    /** Copy for the promo button */
    buttonCopy: PropTypes.string,

    /** Url for the promo */
    href: PropTypes.string,

    /** AltText for the promo button */
    alt: PropTypes.string,

    /** Does this promo direct users to a Rec splash page, or external site */
    isInternalLink: PropTypes.bool,

    /** Added to existing classes */
    className: PropTypes.string,
};

RentalsPromoAside.defaultProps = {
    copy: 'Learn more about gear rental options for your trip.',
    buttonCopy: 'Rental Options',
    href: '/rentals',
    alt: 'Gear Rental Options For this Location',
    isInternalLink: true,
    className: undefined,
};
